import(/* webpackMode: "eager" */ "/app/app/[locale]/(public)/not-found.tsx");
